module.exports = __webpack_public_path__ + "img/01.d70930b8.jpg";